import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import axios from "axios";
import { banner, search } from "../../imgUrl";

const Search = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search).get("q");

  const [query, setQuery] = useState(queryParam || "");
  const [searchResults, setSearchResults] = useState([]);
  const [recentSearches, setRecentSearches] = useState([]); // Track recent searches
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch recent searches from localStorage on mount
  useEffect(() => {
    const storedSearches =
      JSON.parse(localStorage.getItem("recentSearches")) || [];
    setRecentSearches(storedSearches);
  }, []);

  // Function to handle input changes and update the query in URL
  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    navigate(`/search?q=${value}`);
  };

  // Function to update recent searches
  const updateRecentSearches = (searchTerm) => {
    if (!searchTerm) return;

    const updatedSearches = [
      searchTerm,
      ...recentSearches.filter((term) => term !== searchTerm),
    ];
    setRecentSearches(updatedSearches.slice(0, 5)); // Keep only last 5 searches
    localStorage.setItem(
      "recentSearches",
      JSON.stringify(updatedSearches.slice(0, 5))
    );
  };

  // Trigger search when query changes
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      // `${process.env.REACT_APP_API_URL}/documents/get`,

      try {
        const url = query
          ? `${process.env.REACT_APP_API_URL}/all/products?q=${query}`
          : `${process.env.REACT_APP_API_URL}/all/products`; // Default to all products if no query

        const response = await axios.get(url);

        if (response.data && response.data.data) {
          setSearchResults(response.data.data);
          if (query) {
            updateRecentSearches(query); // Add to recent searches
          }
        }
      } catch (err) {
        setError("Something went wrong. Please try again.");
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [query]);

  return (
    <div>
      <div className="main-banner">
        {/* Search Section */}
        <div className="container my-5">
          <div className="serach-box-data">
            <div className="row justify-content-center">
              <div className="col-sm-6">
                <div className="my-5">
                  <div className="search-box">
                    <input
                      type="text"
                      placeholder="Search Medicines"
                      value={query}
                      onChange={handleInputChange}
                    />
                    <img src={search} alt="search icon" />
                  </div>
                </div>
              </div>
            </div>

            {/* Recent Searches Section */}
            {/* {!query && recentSearches.length > 0 && (
              <div className="row justify-content-center">
                <div className="col-sm-6">
                  <h4>Recent Searches:</h4>
                  <ul className="list-group">
                    {recentSearches.map((searchTerm, index) => (
                      <li
                        key={index}
                        className="list-group-item"
                        onClick={() => setQuery(searchTerm)}
                        style={{ cursor: "pointer" }}
                      >
                        {searchTerm}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )} */}

            <div className="row justify-content-center">
              <div className="col-sm-10">
                {/* Show loading, error, or search results */}
                {loading && <p>Loading...</p>}
                {error && <p>{error}</p>}
                {!loading && searchResults && searchResults.length > 0 && (
                  <div className="search-results">
                    <div className="line-sub">
                      <div className="action row search-form">
                      {searchResults.map((product) => {
                                                    const variant = product.variant[0]; // Assuming you are always taking the first variant
                                                    const price = variant?.price || 0;
                                                    const discountPercentage =
                                                        product.variant[0]?.discount?.discount || 0;
                                                    const discountedPrice =
                                                        price - (price * discountPercentage) / 100;
                                                    // Check if price and discounted price are valid numbers before calculating the discount
                                                    const hasValidPrice =
                                                        price &&
                                                        discountedPrice &&
                                                        price > 0 &&
                                                        discountedPrice > 0 &&
                                                        discountPercentage > 0;

                                                    return (
                                                        <div
                                                            className="a1 col-sm-2 col-lg-2 col-md-4 mb-3 search-form-section"
                                                            key={product._id}
                                                        >
                                                            <Link
                                                                className="search-link"
                                                                to={`/productdetails/${product._id}`}
                                                            >
                                                                <img
                                                                    src={
                                                                        product.mediaFiles.length > 0 &&
                                                                        product.mediaFiles[0]?.url
                                                                            ? product.mediaFiles[0].url
                                                                            : "https://placehold.jp/200x200.png"
                                                                    }
                                                                    alt={product.title}
                                                                    width="100%"
                                                                />
                                                                <h3>{product.title}</h3>
                                                                <div className="inndr-main">
                                                                    <div className="inter">
                                                                        <a href="#">
                                                                            ₹{discountedPrice.toFixed(2)}{" "}
                                                                            <del>(₹{price})</del>
                                                                        </a>
                                                                    </div>
                                                                    <div className="otter">
                                                                          {hasValidPrice &&
                                                                            `${discountPercentage}% off`}
                                                                        {/* {hasValidPrice &&
                                                                            `${discountPercentage}% off`} */}
                                                                    </div>
                                                                </div>
                                                            </Link>
                                                            {/* <div className="add-to-cart-btn">
                                                                <button className="ready">ADD TO CART</button>
                                                            </div> */}
                                                        </div>
                                                    );
                                                })}
                      </div>
                    </div>
                  </div>
                )}

                {/* Show message if no products are found */}
                {!loading && query && searchResults.length === 0 && (
                  <p>No products found.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
